import React from "react";

import Form from "antd/es/form";
import { defineMessages, useIntl } from "react-intl";

import stageIcon from "@app/assets/icons/deal-stage-dark.svg";
import StageSelectBox from "@app/component/input/StageSelectBox";
import CardConfigurationProps from "@app/scene/dashboard/types/CardConfigurationProps";
import isClosedStage from "@app/util/isClosedStage";

const messages = defineMessages({
  stages: {
    id: "dashboard.editModal.criteria.closedStageDealCount.stages",
    defaultMessage: "Stages(s)",
    description:
      "Title of the Stages field in a criteria form in Edit Deals Count Modal on Dashboard",
  },
});

interface Props extends CardConfigurationProps {}

const CriteriaFormComponent: React.FC<Props> = () => {
  const intl = useIntl();

  return (
    <div>
      <Form.Item label={intl.formatMessage(messages.stages)} name={["criteria", "dealStageIds"]}>
        <StageSelectBox
          allowClear
          filterStages={isClosedStage}
          prefixIcon={<img alt="stage icon" src={stageIcon} />}
          size="large"
        />
      </Form.Item>
    </div>
  );
};

export default CriteriaFormComponent;
